
import { Component, Prop, PropSync, Vue } from "vue-property-decorator";

@Component
export default class ebiActionsButtonBar extends Vue {
	// @PropSync('visible', { type: Boolean }) private show!: boolean;
	// @Prop() private title!: string;
}
